(function () {
  window.Zero = window.Zero || {};
  window.Zero.Cart = window.Zero.Cart || {};

  var preorderSyncPromise = null;
  var preorderSyncQueued = false;

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return '/';
  }

  function getCartEndpoint(path) {
    return ''.concat(getShopifyRoot(), path);
  }

  function isPreorderFlag(value) {
    return value === true || value === 'true' || value === 'True' || value === 1 || value === '1';
  }

  function normalizeContainsPreorder(value) {
    return isPreorderFlag(value) ? 'true' : '';
  }

  function hasPreorderItem(cart) {
    if (!cart || !Array.isArray(cart.items)) {
      return false;
    }

    return cart.items.some(function (item) {
      if (!item || !item.properties || typeof item.properties !== 'object') {
        return false;
      }

      return isPreorderFlag(item.properties._preorder);
    });
  }

  function fetchCart() {
    return fetch(getCartEndpoint('cart.js'), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to fetch cart.js');
      }

      return response.json();
    });
  }

  function updateContainsPreorder(desiredValue) {
    return fetch(getCartEndpoint('cart/update.js'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          contains_preorder: desiredValue,
        },
      }),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to update contains_preorder cart attribute');
      }

      return response.json();
    });
  }

  async function syncPreorderCartAttribute() {
    if (preorderSyncPromise) {
      preorderSyncQueued = true;
      return preorderSyncPromise;
    }

    preorderSyncPromise = (async function () {
      var cart = null;

      do {
        preorderSyncQueued = false;
        cart = await fetchCart();

        var desiredValue = hasPreorderItem(cart) ? 'true' : '';
        var currentValue = normalizeContainsPreorder(cart && cart.attributes ? cart.attributes.contains_preorder : '');

        if (currentValue !== desiredValue) {
          cart = await updateContainsPreorder(desiredValue);
        }
      } while (preorderSyncQueued);

      return cart;
    })()
      .catch(function (error) {
        console.error('Failed to sync contains_preorder cart attribute.', error);
        return null;
      })
      .finally(function () {
        preorderSyncPromise = null;
      });

    return preorderSyncPromise;
  }

  window.Zero.Cart.syncPreorderCartAttribute = syncPreorderCartAttribute;
  window.syncPreorderCartAttribute = syncPreorderCartAttribute;
})();
